<template>
  <section class="section" :class="bg"
    :style="{'background-image': `url(${customBg})`}"
    v-on:click="sectionClicked">
    <div class="logoInBg"></div>
    <div class="bg4Cnt" v-if="bg === 'bg4'">
      <div class="earthCnt">
        <div class="earth"></div>
        <div class="satelite"></div>
      </div>
      <div class="rocketL"></div>
      <div class="rocketR"></div>
      <div class="beautyPlanet"></div>
      <div class="farPlanet"></div>
      <div class="bgBot"></div>
      <div class="ufo"></div>
      <div class="healthyPlanet"></div>
    </div>
    <div class="profileCnt">
      <div class="score sIcon sound" v-on:click="$emit('playPause')">
        <img src="../assets/music.png" v-if="audioPlaying">
        <img src="../assets/mute.png" v-else>
      </div>
      <div class="score sIcon info" v-on:click="openInfo">
        <img src="../assets/info-black.png">
      </div>
      <div class="score sIcon notif" v-on:click.stop="openNotif">
        <img src="../assets/notification-black.png">
        <div class="ntf" v-if="notifUread > 0">{{notifUread}}</div>
        <div class="notifMenu" v-if="notifOpen" v-on:click.stop="doNothing">
          <div class="notifHeader">Notifikasi</div>
          <div class="notifContent loadingNotif" v-if="loadingNotif"></div>
          <div class="notifContent noNotif" v-else-if="notif.length < 1">
            <img src="../assets/no-notif2.png">
            <h4>Belum Ada Notifikasi</h4>
            <p>Semua notifikasi kamu akan muncul disini</p>
          </div>
          <div class="notifContent" v-else>
            <li v-for="(item, i) in notif" :key="`notif${i}`"
              v-on:click.stop="openNotifItem(item)">
              <h4>{{item.title}}</h4>
              <p v-if="item.message">{{item.message}}</p>
            </li>
          </div>
        </div>
      </div>
      <div class="score" v-on:click="openLevel">
        <div class="ntf" v-if="unclaimedCount > 0">{{unclaimedCount}}</div>
        {{point}}
        <span>Point</span>
      </div>
      <div class="profile" :class="{finisher: point >= 1640}" v-on:click="openProfile">
        <div class="ntf" v-if="completed">1</div>
        <div class="profilePict" v-if="avatar"
          :style="{'background-image': `url(${avatar})`}"></div>
        <div class="profilePict" v-else>
          <span v-if="name">{{name.substr(0, 2).toUpperCase()}}</span>
        </div>
        <h4>{{name}}</h4>
        <p><span class="finisher" v-if="point >= 1640">FINISHER</span><span
          class="bull" v-if="point >= 1640">&bull;</span>No. ABO: {{aboNo}}</p>
      </div>
    </div>
    <div class="charCnt" :class="{charAn: charAn}">
      <div class="theChar" :class="[selectedChar, bmiType, iddle]">
        <div class="headCnt" :class="accTop">
          <div class="head default1"></div>
          <div class="head default2"></div>
          <div class="head badut"></div>
          <div class="head indo"></div>
          <div class="head gym"></div>
          <div class="head sekolah"></div>
          <div class="head gym2"></div>
          <div class="head farmer"></div>
          <div class="head bodykey"></div>
          <div class="head lab"></div>
          <div class="head indo2"></div>
          <div class="head paskib"></div>
          <div class="head hero"></div>
          <div class="head ai30"></div>
          <div class="head astro"></div>
        </div>
        <div class="faceCnt" :class="accMid">
          <div class="face default1"></div>
          <div class="face default2"></div>
          <div class="face badut"></div>
          <div class="face indo"></div>
          <div class="face gym"></div>
          <div class="face sekolah"></div>
          <div class="face gym2"></div>
          <div class="face farmer"></div>
          <div class="face bodykey"></div>
          <div class="face lab"></div>
          <div class="face indo2"></div>
          <div class="face paskib"></div>
          <div class="face hero"></div>
          <div class="face ai30"></div>
          <div class="face astro"></div>
        </div>
        <div class="bodyCnt" :class="accBot">
          <div class="body default1"></div>
          <div class="body default2"></div>
          <div class="body badut"></div>
          <div class="body indo"></div>
          <div class="body gym"></div>
          <div class="body sekolah"></div>
          <div class="body gym2"></div>
          <div class="body farmer"></div>
          <div class="body bodykey"></div>
          <div class="body lab"></div>
          <div class="body indo2"></div>
          <div class="body paskib"></div>
          <div class="body hero"></div>
          <div class="body ai30"></div>
          <div class="body astro"></div>
        </div>
        <div class="finisherCnt">
          <div class="finisher" v-if="finisherBk2"></div>
          <div class="finisher bk3" v-if="point >= 1640"></div>
        </div>
      </div>
      <div class="theChar theChar2" :class="[selectedChar, bmiType, iddle]">
        <div class="headCnt" :class="accTop">
          <div class="head default1"></div>
          <div class="head default2"></div>
          <div class="head badut"></div>
          <div class="head indo"></div>
          <div class="head gym"></div>
          <div class="head sekolah"></div>
          <div class="head gym2"></div>
          <div class="head farmer"></div>
          <div class="head bodykey"></div>
          <div class="head lab"></div>
          <div class="head indo2"></div>
          <div class="head paskib"></div>
          <div class="head hero"></div>
          <div class="head ai30"></div>
          <div class="head astro"></div>
        </div>
        <div class="faceCnt" :class="accMid">
          <div class="face default1"></div>
          <div class="face default2"></div>
          <div class="face badut"></div>
          <div class="face indo"></div>
          <div class="face gym"></div>
          <div class="face sekolah"></div>
          <div class="face gym2"></div>
          <div class="face farmer"></div>
          <div class="face bodykey"></div>
          <div class="face lab"></div>
          <div class="face indo2"></div>
          <div class="face paskib"></div>
          <div class="face hero"></div>
          <div class="face ai30"></div>
          <div class="face astro"></div>
        </div>
        <div class="bodyCnt" :class="accBot">
          <div class="body default1"></div>
          <div class="body default2"></div>
          <div class="body badut"></div>
          <div class="body indo"></div>
          <div class="body gym"></div>
          <div class="body sekolah"></div>
          <div class="body lab"></div>
          <div class="body gym2"></div>
          <div class="body farmer"></div>
          <div class="body bodykey"></div>
          <div class="body indo2"></div>
          <div class="body paskib"></div>
          <div class="body hero"></div>
          <div class="body ai30"></div>
          <div class="body astro"></div>
        </div>
        <div class="finisherCnt">
          <div class="finisher" v-if="finisherBk2"></div>
          <div class="finisher bk3" v-if="point >= 1640"></div>
        </div>
      </div>
    </div>
    <div class="actCnt actCnt2">
      <div class="act actR">
        <div class="actItem chatGroup" v-on:click="openGroup">
          <span>Chat<br />Group</span>
          <div class="ntf ntfReal" v-if="chatUnread > 0">{{chatUnread}}</div>
        </div>
        <router-link to="/meal-plan" class="actItem mealPlan">
          <span>Meal<br />Plan</span>
        </router-link>
      </div>
    </div>
    <div class="actCnt">
      <div class="act actR">
        <div class="actItem share" v-on:click="$router.push('/body-composition')"
          v-if="!uploadBefore">
          <div class="ntf ntf2">!</div>
          Lengkapi Data Diri
        </div>
        <div class="actItem share" v-on:click="openSelfie">
          <div class="ntf ntf2"></div>
          Buat<br />GIF
        </div>
        <div class="actItem share" v-on:click="share">
          Bagikan Karakter
        </div>
        <div class="actItem changeBg" v-on:click="changeBg">
          <!-- <div class="ntf ntf2"></div> -->
          Ganti<br />Latar
        </div>
        <div class="actItem cosmetic" v-on:click="openAcc">
          <!-- <div class="ntf ntf2"></div> -->
          Ganti Aksesoris
        </div>
      </div>
    </div>
    <div class="calendarOverlay" v-if="calOpen"
      v-on:click="calOpen = false"></div>
    <div class="calendarCnt">
      <div class="calendar" v-on:click="calOpen = !calOpen"
        :class="{open: calOpen}">
        <h4>Kalender Challenge 14 Hari</h4>
        <div class="calSc">
          <div class="calCnt" v-if="loadingChallenge">
            <div class="calItem loading"
              v-for="i in 14" :key="i"></div>
          </div>
          <div class="calCnt" v-else>
            <div :class="{calItem: true, completed: item.challengeCompleted,
              locked: nextDay < item.publishDate,
              passed: item.publishDate <= prevDay, allCompleted: completed}"
              v-for="(item, i) in challenges" :key="i"
              v-on:click="openMission(item)">
              <div class="calIcon"></div>
              <span>Day</span>{{i+1}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <ChangeBg ref="changeBg"/>
    <Welcome ref="welcome"/>
    <Info ref="info"/>
    <Confetti ref="confetti"/>
    <ShareDialog ref="shareDialog"/>
    <Selfie ref="seflieDialog"/>
    <Profile ref="profile"/>
    <Level ref="level"/>
    <ChangeAcc ref="changeAcc"/>
    <ChatGroup ref="chatGroup"/>
    <PushNotif ref="pushNotif"/>
    <UpdateAddress ref="updateAddress"/>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Welcome from '@/components/Welcome.vue';
import ChangeBg from '@/components/ChangeBg.vue';
import Info from '@/components/Info.vue';
import Confetti from '@/components/Confetti.vue';
import ShareDialog from '@/components/ShareDialog.vue';
import Selfie from '@/components/Selfie.vue';
import Profile from '@/components/Profile.vue';
import Level from '@/components/Level.vue';
import ChangeAcc from '@/components/ChangeAcc.vue';
import ChatGroup from '@/components/ChatGroup.vue';
import PushNotif from '@/components/PushNotif.vue';
import UpdateAddress from '@/components/UpdateAddress.vue';

export default {
  name: 'home',
  components: {
    Welcome,
    ChangeBg,
    Info,
    Confetti,
    ShareDialog,
    Selfie,
    Profile,
    Level,
    ChangeAcc,
    ChatGroup,
    PushNotif,
    UpdateAddress,
  },
  data() {
    return {
      st: 'reg',
      calOpen: false,
      avatar: null,
      name: null,
      selectedChar: 'nunu',
      bmiType: 'normal',
      aboNo: '. . .',
      accTop: 'none',
      accMid: 'none',
      accBot: 'none',
      finisher: false,
      point: 0,
      unclaimedCount: 0,
      loadingChallenge: true,
      challenges: [],
      bg: 'bg1',
      customBg: null,
      charAn: false,
      completed: false,
      notifOpen: false,
      finisherBk2: false,
      uploadBefore: false,

      now: 0,
      prevDay: 0,
      nextDay: 0,

      /**
       * Iddle
       *
       */
      iddle: null,

      /**
       * Notif and chat
       *
       */
      chatUnread: 0,
      loadingNotif: true,
      notifUread: 0,
      notif: [],
    };
  },
  created() {},
  destroyed() {
    clearTimeout(iddleTimer);
    clearInterval(charInterval);
  },
  methods: {
    doNothing() {},
    openSelfie() { this.$refs.seflieDialog.open(); },
    openProfile() { this.$refs.profile.open(); },
    openLevel() { this.$refs.level.open(); },
    share() { this.$refs.shareDialog.open(); },
    openGroup() {
      this.$refs.chatGroup.open(null, () => {
        this.countChat();
      });
    },
    countChat() {
      this.$http.get(this.$config.uri('group/unread')).then((r) => {
        this.chatUnread = (r.data.status === 200) ? r.data.unreadCount : 0;
      });
    },
    countNotif() {
      this.$http.get(this.$config.uri('user/notif/unread')).then((r) => {
        this.notifUread = (r.data.status === 200) ? r.data.unreadCount : 0;
      });
    },
    openNotif() {
      if (this.notifOpen) {
        this.notifOpen = false;
        return;
      }
      this.notifOpen = true;
      this.loadingNotif = true;
      this.$http.get(this.$config.uri('user/notif')).then((r) => {
        this.loadingNotif = false;
        this.notif = (r.data.status === 200) ? r.data.data : [];
        this.countNotif();
      });
    },
    openNotifItem(item) {
      this.notifOpen = false;
      if (item.type === 'finisher') {
        this.openProfile();
      } else if (item.type === 'group') {
        this.openGroup();
      }
    },
    openAcc() {
      this.$refs.changeAcc.open(null, () => {
        this.accTop = this.$session.get('bk6_accTop') || 'none';
        this.accMid = this.$session.get('bk6_accMid') || 'none';
        this.accBot = this.$session.get('bk6_accBot') || 'none';
        this.bg = this.$session.get('bk6_bg') || 'bg1';
      });
    },
    openInfo() { this.$refs.welcome.open(); },
    sectionClicked() {
      this.notifOpen = false;
      this.iddle = null;
      clearTimeout(iddleTimer);
      iddleTimer = setTimeout(() => {
        this.iddle = { iddle: true };
      }, 8000);
    },
    changeBg() {
      this.$refs.changeBg.open(null, (b, bg, customBg) => {
        if (!b) return;
        this.bg = bg;
        this.customBg = customBg;
        this.accTop = this.$session.get('bk6_accTop') || 'none';
        this.accMid = this.$session.get('bk6_accMid') || 'none';
        this.accBot = this.$session.get('bk6_accBot') || 'none';
      });
    },
    openMission(item) {
      // this.$router.push(`/mission/day/${item.slug}`);
      if (item.publishDate <= this.prevDay && !this.completed) {
        this.$refs.info.open({
          title: 'Challenge Sudah Lewat',
          description: `Kamu bisa membuka kembali challenge ini
            setelah masa challenge 14 hari selesai.`,
        });
      } else if (this.nextDay < item.publishDate) {
        this.$refs.info.open({
          title: 'Challenge Terkunci',
          description: 'Challenge ini belum dimulai, mohon periksa kembali lagi nanti.',
        });
      } else {
        this.$router.push(`/mission/day/${item.slug}`);
      }
    },
    urlB64ToUint8Array(base64String) {
      // eslint-disable-next-line
      const padding = '='.repeat((4 - base64String.length % 4) % 4);
      const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
      const rawData = window.atob(base64);
      const outputArray = new Uint8Array(rawData.length);
      for (let i = 0; i < rawData.length; i += 1) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    initNotif() {
      if (this.$session.get('bk6_notif_asked') !== 'y') {
        const ns = setInterval(() => {
          if (swRegisterd.status) {
            clearInterval(ns);
            this.regNotif();
            this.$session.set('bk6_notif_asked', 'y');
          }
        }, 500);
      }
    },
    async regNotif() {
      if (this.$session.get('bk6_notif') === 'denied') {
        // eslint-disable-next-line
        console.error('User already denied push notification');
        return;
      }
      if (!('serviceWorker' in navigator)) {
        // eslint-disable-next-line
        console.error('Service Worker isn\'t supported on this browser, disable or hide UI.');
        return;
      }
      if (!('PushManager' in window)) {
        // eslint-disable-next-line
        console.error('Push isn\'t supported on this browser, disable or hide UI.');
        return;
      }
      const registration = await navigator.serviceWorker.getRegistration();
      if (!registration) {
        // eslint-disable-next-line
        console.error('Service worker not registered');
        return;
      }
      const subscribed = await registration.pushManager.getSubscription();
      if (subscribed) {
        // eslint-disable-next-line
        console.info('User is already subscribed.');
        return;
      }
      this.$refs.pushNotif.open(null, async (b) => {
        if (!b) return;
        const result = await Notification.requestPermission();
        if (result === 'denied') {
          // eslint-disable-next-line
          console.error('The user explicitly denied the permission request.');
          this.$session.set('bk6_notif', 'denied');
          return;
        }
        if (result === 'granted') {
          // eslint-disable-next-line
          console.info('The user accepted the permission request.');
        }
        const pubKey = 'BPyaf5vNoV46na0iEUyhmitsBGPz2PRCDxfhdhcshi_DMKFqqFkykaAYwyVIDhopjIv632bBfyQ-GmpRJiR2H8w';
        const subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: this.urlB64ToUint8Array(pubKey),
        });
        this.$http.post(this.$config.uri('user/notif/register'), subscription).then((r) => {
          // eslint-disable-next-line
          console.info('Push notification ready');
        });
      });
    },
  },
  computed: {
    ...mapState(['audioPlaying', 'audioMuted']),
  },
  mounted() {
    // Check login
    if (!this.$session.get('bk6_email')) {
      this.$router.push('/login');
      return;
    }
    this.$http.get(this.$config.uri('user/status')).then((r) => {
      if (r.data.status !== 200) {
        this.$session.destroy();
        this.$router.push('/login');
      }
    });

    this.$http.get(this.$config.uri('user/updated')).then((r) => {
      if (r.data.status !== 200) {
        this.$refs.updateAddress.open(null, (b) => {
          if (!b) return;
          this.$router.push('/t-shirt/size');
        });
      }
    });


    this.$socket.emit('sign', {
      key: this.$config.apiKey,
      token: this.$session.get('bk6_jwt'),
    });
    // this.sockets.unsubscribe('notif');
    // this.sockets.subscribe('notif', (msg) => {});
    this.sockets.unsubscribe('broadcast');
    this.sockets.subscribe('broadcast', (msg) => {
      this.chatUnread += 1;
    });

    this.countChat();
    this.countNotif();

    /**
     * Check is user uploaded before photo
     *
     */
    this.$http.get(this.$config.uri('user/upload-before')).then((r) => {
      this.uploadBefore = (r.data.status === 200 && r.data.uploaded_photo_before);
    });

    if (!this.audioPlaying && !this.audioMuted && !localStorage.getItem('audioMuted')) this.$emit('play');
    if (!this.$session.get('bk6_welcome')) {
      this.$session.set('bk6_welcome', 'y');
      this.$refs.welcome.open(null, () => {
        this.initNotif();
      });
    } else {
      this.initNotif();
    }
    clearTimeout(iddleTimer);
    iddleTimer = setTimeout(() => {
      this.iddle = { iddle: true };
    }, 8000);
    clearInterval(charInterval);
    charInterval = setInterval(() => {
      this.charAn = !this.charAn;
    }, 800);
    const d = new Date();

    /**
     * pd = Previous day
     * pn = Next day
     *
     */
    const pd = new Date();
    const pn = new Date();
    pd.setDate(pd.getDate() - 1);
    pd.setHours(23);
    pd.setMinutes(59);
    pn.setDate(pn.getDate() + 1);
    pn.setHours(23);
    pn.setMinutes(0);
    this.now = Math.floor(d.getTime() / 1000);
    this.prevDay = Math.floor(pd.getTime() / 1000);
    this.nextDay = Math.floor(pn.getTime() / 1000);

    /**
     * d2 = Challenge completed
     *
     */
    const d2 = new Date();
    d2.setDate(15);
    d2.setMonth(5);
    d2.setFullYear(2023);
    d2.setHours(0);
    d2.setMinutes(0);
    this.completed = d.getTime() >= d2.getTime();
    this.bg = this.$session.get('bk6_bg') || 'bg1';
    this.customBg = this.$session.get('bk6_customBg');
    this.name = this.$session.get('bk6_name');
    this.avatar = this.$session.get('bk6_avatar');
    this.accTop = this.$session.get('bk6_accTop') || 'none';
    this.accMid = this.$session.get('bk6_accMid') || 'none';
    this.accBot = this.$session.get('bk6_accBot') || 'none';
    this.selectedChar = this.$session.get('bk6_character') || 'nunu';
    this.bmiType = this.$session.get('bk6_bmiType') || 'normal';
    this.finisher = this.$session.get('bk6_finisher');
    this.point = this.$session.get('bk6_point') || 0;
    this.finisherBk2 = this.$session.get('bk6_finisherBk2');
    this.$http.get(this.$config.uri('content/all/admin?parent=challenges&status=published&reverse=y')).then((r) => {
      this.loadingChallenge = false;
      this.challenges = (r.data.status === 200) ? r.data.data : [];
    });
    this.$http.get(this.$config.uri('user/price/unclaimed/count')).then((r) => {
      this.unclaimedCount = (r.data.status === 200) ? r.data.total : 0;
    });
    this.$http.get(this.$config.uri('user/abo/number')).then((r) => {
      if (r.data.status === 401) {
        this.$session.destroy();
        this.$router.push('/login');
        return;
      }
      this.aboNo = (r.data.status === 200) ? r.data.data : 'Unknown';
    });
    this.$http.get(this.$config.uri('user/point')).then((r) => {
      if (r.data.status === 200) {
        this.point = r.data.point || 0;
        this.$session.set('bk6_point', this.point);
        if (r.data.finisherBk2 === 1) {
          this.finisherBk2 = true;
          this.$session.get('bk6_finisherBk2', true);
        }
      }
    });
  },
};
</script>

<style scoped lang="scss">
@keyframes rotator {
  from { transform: rotate(0) }
  to { transform: rotate(360deg) }
}
@keyframes rotator-reverse {
  from { transform: rotate(360deg) }
  to { transform: rotate(0) }
}
@keyframes planet {
  0% { transform: translateY(0) }
  50% { transform: translateY(10px); }
  100% { transform: translateY(0); }
}
.section{
  padding: 0 10px 40px;
  position: fixed;
  overflow: auto;
  left: 150px; top: 0; right: 0; bottom: 0;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  @media (max-width: 768px) {
    left: 0; top: 60px;
  }
  .logoInBg{
    position: absolute;
    height: 280px;
    left: 50%; top: 100px;
    width: 240px;
    margin-left: -120px;
    background-position: top center;
    background-size: contain;
    background-repeat: no-repeat;
    @media (min-width: 680px) {
      width: 360px; margin-left: -180px;
    }
  }
  .bg4Cnt{
    position: absolute;
    left: 0; right: 0; bottom: 0; top: 0;
    overflow: hidden;
    z-index: 1;
    .bgBot{
      height: 560px;
      position: absolute;
      left: 0; right: 0; bottom: 0;
      background-image: url(../assets/pijakan.png);
      background-size: cover;
      background-position: bottom center;
      background-repeat: no-repeat;
      z-index: 4;
    }
    .ufo{
      position: absolute;
      width: 240px; height: 120px;
      left: 80px; bottom: 180px;
      background-image: url(../assets/bg-ornamen-bawah2.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 1;
      animation: planet 5s ease forwards infinite;
      @media (max-width: 1480px) {
        height: 100px; width: 200px;
      }
      @media (max-width: 860px) {
        width: 120px; height: 120px;
        left: 0;
      }
    }
    .healthyPlanet{
      position: absolute;
      width: 240px; height: 200px;
      right: 40px; bottom: 120px;
      background-image: url(../assets/bg-ornamen-bawah-2.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 1;
      animation: planet 5s ease forwards infinite;
      @media (max-width: 1480px) {
        width: 180px; height: 160px; bottom: 160px;
      }
      @media (max-width: 860px) {
        width: 100px; height: 100px;
        right: 0; bottom: 180px;
      }
    }
    .rocketL{
      position: absolute;
      width: 3400px; height: 3400px;
      left: 50%; top: 50%;
      margin: -300px 0 0 -1700px;
      border-radius: 50%;
      animation: rotator 120s linear infinite;
      @media (max-width: 860px) {}
      &:before{
        content: "";
        position: absolute;
        top: 420px; left: 420px;
        width: 100px; height: 100px;
        background-image: url(../assets/roket2.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        transform: rotate(-45deg);
      }
    }
    .rocketR{
      position: absolute;
      width: 3400px; height: 3400px;
      left: 50%; top: 50%;
      margin: -400px 0 0 -1900px;
      border-radius: 50%;
      animation: rotator-reverse 94s linear infinite;
      &:before{
        content: "";
        position: absolute;
        top: 50%; right: -100px;
        margin-top: -50px;
        width: 160px; height: 160px;
        background-image: url(../assets/roket1.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        transform: rotate(90deg);
      }
    }
    .earthCnt{
      position: absolute;
      width: 150px; height: 150px;
      left: 50%; top: 100px;
      margin-left: -200px;
      animation: planet 5s ease forwards infinite;
      z-index: 9;
      @media (max-width: 1480px) {
        width: 120px; height: 120px;
      }
      @media (max-width: 860px) {
        width: 96px; height: 96px;
        left: 120px; margin-left: 0;
      }
    }
    .earth{
      position: absolute;
      width: 100%; height: 100%;
      left: 0; top: 0;
      background-image: url(../assets/earth.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 2;
      animation: rotator 48s linear infinite;
    }
    .satelite{
      position: absolute;
      width: 100%; height: 100%;
      left: 0; top: 0;
      animation: rotator 24s linear infinite;
      &:before{
        content: "";
        position: absolute;
        top: -28px; right: -28px;
        width: 46px; height: 46px;
        background-image: url(../assets/satelite.png);
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        @media (max-width: 860px) {
          width: 36px; height: 36px;
          top: -20px; right: -20px;
        }
      }
    }
    .beautyPlanet{
      position: absolute;
      width: 160px; height: 160px;
      left: 50%; top: 180px;
      margin-left: 140px;
      background-image: url(../assets/bg-ornamen-atas-2.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 1;
      animation: planet 5s ease forwards infinite;
      @media (max-width: 1480px) {
        top: 140px; margin-left: 100px;
      }
      @media (max-width: 860px) {
        width: 120px; height: 120px;
        left: auto; margin-left: 0;
        right: 40px; top: 180px;
      }
    }
    .farPlanet{
      animation: planet 5s ease forwards infinite;
      position: absolute;
      width: 120px; height: 120px;
      left: 50%; top: 220px;
      margin-left: -480px;
      background-image: url(../assets/bg-ornamen-atas-3.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 1;
      @media (max-width: 860px) {
        margin-left: 0; left: -60px; top: 200px;
      }
    }
  }
  &.bg1{
    background-image: url(../assets/bg-1-default.png) !important;
    .logoInBg{
      top: 120px;
      width: 180px;
      margin-left: -90px;
      background-image: url(../assets/logo-bg-1.png);
      @media (min-width: 680px) {
        width: 260px; margin-left: -130px;
      }
    }
  }
  &.bg2{
    background-image: url(../assets/bg-2-lv7.png) !important;
    .logoInBg{
      background-image: url(../assets/logo-bg-2.png);
    }
  }
  &.bg3{
    background-image: url(../assets/bg-3-lv14.png) !important;
    .logoInBg{
      background-image: url(../assets/logo-bg-3.png);
    }
  }
  &.bg4{
    background-image: url(../assets/bg4-bg.png) !important;
    .logoInBg{
      display: none;
    }
  }
  &.custom{
    .logoInBg{
      top: 120px;
      width: 180px;
      margin-left: -90px;
      background-image: url(../assets/logo-bg-1.png);
      @media (min-width: 680px) {
        width: 260px; margin-left: -130px;
      }
    }
  }
}
.profileCnt{
  padding: 20px 0 0;
  display: flex;
  color: #494e00;
  transition: all .3s ease;
  // max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 9;
  @media (min-width: 681px) {
    padding: 20px 10px 0;
  }
  .ntf{
    width: auto;
    min-width: 19px;
    height: 19px;
    background-color: red;
    border-radius: 10px;
    position: absolute;
    right: -2px; top: -2px;
    font-size: 13px;
    padding: 2px 5px 0;
    box-sizing: border-box;
    color: #fff;
    text-align: center;
    font-weight: bold;
  }
  .score{
    width: 60px; height: 60px;
    background-color: #cddd00;
    border-radius: 50%;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    padding-top: 14px;
    box-sizing: border-box;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
    position: relative;
    z-index: 7;
    transition: all .3s ease;
    cursor: pointer;
    margin-left: 16px;
    @media (max-width: 680px) {
      margin-left: auto;
    }
    &:hover{
      background-color: #bccb03;
    }
    &.sound{
      margin-left: auto;
    }
    &.notif{
      z-index: 8;
      @media (max-width: 680px) {
        margin-left: 0;
      }
    }
    &.sIcon{
      img{
        width: 30px;
      }
      &.notif{
        padding-top: 10px;
        img{
          width: 36px;
        }
        .notifMenu{
          position: absolute;
          right: 0; top: 100%;
          background-color: #fff;
          box-shadow: 0 2px 6px rgba(0, 0, 0, .2);
          width: 300px;
          border-radius: 5px;
          z-index: 991;
          @media (max-width: 920px) {
            right: auto;
            left: 0;
          }
          .notifHeader{
            font-size: 17px;
            padding: 16px 30px 10px;
            border-bottom: #eee 1px solid;
            text-align: left;
            color: #444;
          }
          .notifContent{
            min-height: 300px;
            max-height: 360px;
            overflow-y: auto;
            padding-bottom: 10px;
            &.loadingNotif{
              background-image: url(../assets/loading.svg);
              background-size: 36px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
            &.noNotif{
              padding: 40px 40px 50px;
              text-align: center;
              img{
                width: 120px;
                margin: 0 0 20px;
              }
              h4{
                margin: 0 0 4px;
                font-size: 20px;
              }
              p{
                margin: 0;
                font-weight: 400;
                font-size: 14px;
                color: #767676;
              }
            }
          }
          li{
            list-style: none;
            text-align: left;
            padding: 8px 30px;
            color: #444;
            transition: all .3s ease;
            &:hover{
              background-color: #f5f5fe;
            }
            h4{
              margin: 0;
              font-size: 15px;
              font-weight: 600;
            }
            p{
              margin: 0;
              font-size: 13px;
              font-weight: 400;
              color: #767676;
            }
          }
        }
      }
    }
    &.sound, &.info{
      @media (max-width: 680px) {
        position: absolute;
        left: 0; top: 90px;
        // margin-left: 10px;
      }
    }
    &.sound{
      @media (max-width: 680px) {
        top: 160px;
      }
    }
    span{
      font-size: 11px;
      font-weight: normal;
      margin: -4px 0 0;
      display: block;
    }
  }
  .profile{
    height: 60px;
    width: calc(100% - 152px);
    margin-left: 16px;
    background-color: #cddd00;
    border-radius: 100px;
    position: relative;
    box-sizing: border-box;
    padding-top: 10px;
    padding-left: 26px;
    padding-right: 56px;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
    max-width: 340px;
    transition: all .3s ease;
    cursor: pointer;
    @media (max-width: 840px) {
      max-width: 280px;
    }
    @media (max-width: 680px) {
      width: calc(100% - 140px);
      margin-left: 10px;
      max-width: none;
    }
    &:hover{
      background-color: #bccb03;
    }
    &:active{
      box-shadow: none;
      background-color: #bccb03;
    }
    h4{
      margin: 0;
      font-size: 18px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    p{
      margin: 0;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .profilePict{
      width: 46px; height: 46px;
      background-position: center;
      background-size: cover;
      border-radius: 50%;
      position: absolute;
      right: 7px; top: 7px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(0, 0, 0, .2);
      color: #fff;
      font-weight: 600;
    }
    &.finisher{
      .profilePict{
        &:before{
          content: "";
          position: absolute;
          left: -4px; top: -4px; right: -4px; bottom: -4px;
          border-radius: 50%;
          border: #ff3938 2px solid;
          z-index: 3;
        }
      }
      .finisher{
        color: #ff3938;
        font-weight: 600;
        position: relative;
        padding-left: 20px;
        &:before{
          content: "";
          width: 20px; height: 20px;
          background-image: url(../assets/finisher-flag.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          position: absolute;
          left: -4px; top: 0;
        }
      }
      .bull{
        margin: 0 6px;
      }
    }
  }
}
.actCnt{
  position: fixed;
  left: 150px; right: 0; bottom: 76px;
  z-index: 4;
  @media (max-width: 768px) {
    left: 0;
  }
  .act{
    position: absolute;
    z-index: 4;
    transition: all .3s ease;
    bottom: 0;
    &.actL{
      left: 10px;
      @media (min-width: 680px) {
        left: 20px;
      }
    }
    &.actR{
      display: flex;
      width: auto;
      margin: 0; left: 50%;
      transform: translateX(-50%);
    }
    .actItem{
      width: 60px; height: 60px;
      background-color: #cddd00;
      border-radius: 50%;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
      margin: 0 4px 10px;
      text-align: center;
      display: block;
      color: #444;
      font-size: 11px;
      padding-top: 16px;
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #bccb03;
      }
      &.claim{
        display: none;
      }
      .ntf{
        width: 20px;
        height: 20px;
        background-color: red;
        border-radius: 10px;
        position: absolute;
        right: -2px; top: -2px;
        font-size: 13px;
        padding-top: 2px;
        box-sizing: border-box;
        color: #fff;
        &.ntf2{
          width: 16px; height: 16px;
          top: 0; right: 0;
          padding-top: 0;
        }
        &.ntfReal{
          padding: 2px 6px;
          width: auto;
          min-width: 20px;
          box-sizing: border-box;
        }
      }
    }
  }
  &.actCnt2{
    left: auto; bottom: auto;
    top: 100px; right: 20px;
    @media (max-width: 768px) {
      top: 150px;
    }
    @media (max-width: 680px) {
      right: 10px;
    }
    .act{
      display: block;
      position: relative;
      transform: none;
      left: auto; right: auto; top: auto; bottom: auto;
      .actItem{
        margin: 0 0 10px;
        background-color: transparent;
        &:before{
          content: "";
          background-size: 30px auto;
          background-position: center;
          background-repeat: no-repeat;
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
          background-color: #cddd00;
          z-index: 3;
          border-radius: 50%;
        }
        .ntf{
          z-index: 5;
        }
        &.mealPlan{
          &:before{
            background-image: url(../assets/meal-plan.png);
          }
        }
        &.chatGroup{
          &:before{
            background-image: url(../assets/chat-group.png);
            background-size: 26px auto;
          }
        }
        span{
          font-weight: 600;
          position: absolute;
          right: 100%;
          text-align: right;
          margin-right: -6px;
          top: 15px;
          line-height: 1;
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
          background: #c6d600;
          border-radius: 20px 0 0 20px;
          padding: 6px 14px 5px;
        }
      }
    }
  }
}
.section.bg4{
  .actCnt.actCnt2{
    .act{
      .actItem{
        // color: #fff;
      }
    }
  }
}
.charCnt{
  .theChar{
    position: fixed;
    z-index: 3;
    left: 160px; right: 10px; top: 180px; bottom: 120px;
    background-image: url(../assets/char/nunu-normal-1.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    @media (max-width: 768px) {
      left: 10px;
    }
    &.iddle{
      background-image: url(../assets/char/nunu-tidur-normal-1.png);
    }
    &.kurus{
      background-image: url(../assets/char/nunu-kurus-1.png);
      &.iddle{
        background-image: url(../assets/char/nunu-tidur-kurus-1.png);
      }
    }
    &.gemuk{
      background-image: url(../assets/char/nunu-gemuk-1.png);
      &.iddle{
        background-image: url(../assets/char/nunu-tidur-gemuk-1.png);
      }
    }
    &.lili{
      background-image: url(../assets/char/lili-normal-1.png);
      &.iddle{
        background-image: url(../assets/char/lili-tidur-normal-1.png);
      }
      &.kurus{
        background-image: url(../assets/char/lili-kurus-1.png);
        &.iddle{
          background-image: url(../assets/char/lili-tidur-kurus-1.png);
        }
      }
      &.gemuk{
        background-image: url(../assets/char/lili-gemuk-1.png);
        &.iddle{
          background-image: url(../assets/char/lili-tidur-gemuk-1.png);
        }
      }
    }
    .headCnt{
      .head{ visibility: hidden; }
      &.default1{
        .head.default1{ visibility: visible; }
      }
      &.default2{
        .head.default2{ visibility: visible; }
      }
      &.badut{
        .head.badut{ visibility: visible; }
      }
      &.indo{
        .head.indo{ visibility: visible; }
      }
      &.gym{
        .head.gym{ visibility: visible; }
      }
      &.sekolah{
        .head.sekolah{ visibility: visible; }
      }
      &.farmer{
        .head.farmer{ visibility: visible; }
      }
      &.bodykey{
        .head.bodykey{ visibility: visible; }
      }
      &.lab{
        .head.lab{ visibility: visible; }
      }
      &.gym2{
        .head.gym2{ visibility: visible; }
      }
      &.indo2{
        .head.indo2{ visibility: visible; }
      }
      &.paskib1{
        .head.paskib{ visibility: visible; }
      }
      &.hero1{
        .head.hero{ visibility: visible; }
      }
      &.AI30-1{
        .head.ai30{ visibility: visible; }
      }
      &.astro{
        .head.astro{ visibility: visible; }
      }
    }
    .head{
      position: absolute;
      top: 0; left: 0; right: 0; bottom: 0;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      &.default1{
        background-image: url(../assets/acc/acc-winter-atas-1.png);
      }
      &.default2{
        background-image: url(../assets/acc/acc-summer-atas-1.png);
      }
      &.badut{
        background-image: url(../assets/acc/acc-badut-atas-1.png);
      }
      &.indo{
        background-image: url(../assets/acc/acc-indo-atas-1.png);
      }
      &.gym{
        background-image: url(../assets/acc/acc-gym-atas-1.png);
      }
      &.sekolah{
        background-image: url(../assets/acc/acc-sekolah-atas-1.png);
      }
      &.farmer{
        background-image: url(../assets/acc/acc-petani-atas-1.png);
      }
      &.gym2{
        background-image: url(../assets/acc/acc-gym2-atas-1.png);
      }
      &.lab{
        background-image: url(../assets/acc/acc-lab-atas-1.png);
      }
      &.bodykey{
        background-image: url(../assets/acc/acc-bk-atas-1.png);
      }
      &.indo2{
        background-image: url(../assets/acc/acc-indo2-1-atas.png);
      }
      &.paskib{
        background-image: url(../assets/acc/acc-paskib-1-atas.png);
      }
      &.hero{
        background-image: url(../assets/acc/acc-pahlawan-1-atas.png);
      }
      &.ai30{
        background-image: url(../assets/acc/acc-AI30-1-atas.png);
      }
      &.astro{
        background-image: url(../assets/acc/acc-astro-1.png);
      }
    }
    .faceCnt{
      .face{ visibility: hidden; }
      &.default1{
        .face.default1{ visibility: visible; }
      }
      &.default2{
        .face.default2{ visibility: visible; }
      }
      &.badut{
        .face.badut{ visibility: visible; }
      }
      &.indo{
        .face.indo{ visibility: visible; }
      }
      &.gym{
        .face.gym{ visibility: visible; }
      }
      &.sekolah{
        .face.sekolah{ visibility: visible; }
      }
      &.farmer{
        .face.farmer{ visibility: visible; }
      }
      &.bodykey{
        .face.bodykey{ visibility: visible; }
      }
      &.gym2{
        .face.gym2{ visibility: visible; }
      }
      &.lab{
        .face.lab{ visibility: visible; }
      }
      &.indo2{
        .face.indo2{ visibility: visible; }
      }
      &.paskib1{
        .face.paskib{ visibility: visible; }
      }
      &.hero1{
        .face.hero{ visibility: visible; }
      }
      &.AI30-1{
        .face.ai30{ visibility: visible; }
      }
      &.astro{
        .face.astro{ visibility: visible; }
      }
    }
    .face{
      left: 0; right: 0; top: 0; bottom: 0;
      position: absolute;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      &.default1{
        background-image: url(../assets/acc/acc-winter-tengah-1.png);
      }
      &.default2{
        background-image: url(../assets/acc/acc-summer-tengah-1.png);
      }
      &.badut{
        background-image: url(../assets/acc/acc-badut-tengah-1.png);
      }
      &.indo{
        background-image: url(../assets/acc/acc-indo-tengah-1.png);
      }
      &.gym{
        background-image: url(../assets/acc/acc-gym-tengah-1.png);
      }
      &.sekolah{
        background-image: url(../assets/acc/acc-sekolah-tengah-1.png);
      }
      &.farmer{
        background-image: url(../assets/acc/acc-petani-tengah-1.png);
      }
      &.bodykey{
        background-image: url(../assets/acc/acc-bk-tengah-1.png);
      }
      &.gym2{
        background-image: url(../assets/acc/acc-gym2-tengah-1.png);
      }
      &.lab{
        background-image: url(../assets/acc/acc-lab-tengah-1.png);
      }
      &.indo2{
        background-image: url(../assets/acc/acc-indo2-1-tengah.png);
      }
      &.paskib{
        background-image: url(../assets/acc/acc-paskib-1-tengah.png);
      }
      &.hero{
        background-image: url(../assets/acc/acc-pahlawan-1-tengah.png);
      }
      &.ai30{
        background-image: url(../assets/acc/acc-AI30-1-tengah.png);
      }
      &.astro{
        background-image: url(../assets/acc/acc-astro-1.png);
      }
    }
    .bodyCnt{
      .body{ visibility: hidden; }
      &.default1{
        .body.default1{ visibility: visible; }
      }
      &.default2{
        .body.default2{ visibility: visible; }
      }
      &.badut{
        .body.badut{ visibility: visible; }
      }
      &.indo{
        .body.indo{ visibility: visible; }
      }
      &.gym{
        .body.gym{ visibility: visible; }
      }
      &.sekolah{
        .body.sekolah{ visibility: visible; }
      }
      &.farmer{
        .body.farmer{ visibility: visible; }
      }
      &.bodykey{
        .body.bodykey{ visibility: visible; }
      }
      &.lab{
        .body.lab{ visibility: visible; }
      }
      &.gym2{
        .body.gym2{ visibility: visible; }
      }
      &.indo2{
        .body.indo2{ visibility: visible; }
      }
      &.paskib1{
        .body.paskib{ visibility: visible; }
      }
      &.hero1{
        .body.hero{ visibility: visible; }
      }
      &.AI30-1{
        .body.ai30{ visibility: visible; }
      }
      &.astro{
        .body.astro{ visibility: visible; }
      }
    }
    .body{
      left: 0; right: 0; top: 0; bottom: 0;
      position: absolute;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      &.default1{
        background-image: url(../assets/acc/acc-winter-bawah-1.png);
      }
      &.default2{
        background-image: url(../assets/acc/acc-summer-bawah-1.png);
      }
      &.badut{
        background-image: url(../assets/acc/acc-badut-bawah-1.png);
      }
      &.indo{
        background-image: url(../assets/acc/acc-indo-bawah-1.png);
      }
      &.gym{
        background-image: url(../assets/acc/acc-gym-bawah-1.png);
      }
      &.sekolah{
        background-image: url(../assets/acc/acc-sekolah-bawah-1.png);
      }
      &.farmer{
        background-image: url(../assets/acc/acc-petani-bawah-1.png);
      }
      &.gym2{
        background-image: url(../assets/acc/acc-gym2-bawah-1.png);
      }
      &.lab{
        background-image: url(../assets/acc/acc-lab-bawah-1.png);
      }
      &.bodykey{
        background-image: url(../assets/acc/acc-bk-bawah-1.png);
      }
      &.indo2{
        background-image: url(../assets/acc/acc-indo2-1-bawah.png);
      }
      &.paskib{
        background-image: url(../assets/acc/acc-paskib-1-bawah.png);
      }
      &.hero{
        background-image: url(../assets/acc/acc-pahlawan-1-bawah.png);
      }
      &.ai30{
        background-image: url(../assets/acc/acc-AI30-1-bawah.png);
      }
      &.astro{
        background-image: url(../assets/acc/acc-astro-1.png);
      }
    }
    .finisherCnt{
      .finisher{
        left: 0; right: 0; top: 0; bottom: 0;
        position: absolute;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/acc/bendera-finisher2-1.png);
        &.bk3{
          background-image: url(../assets/acc/medali-finisher-1.png);
        }
      }
    }
    &.theChar2{
      display: none;
      background-image: url(../assets/char/nunu-normal-2.png);
      &.iddle{
        background-image: url(../assets/char/nunu-tidur-normal-2.png);
      }
      &.kurus{
        background-image: url(../assets/char/nunu-kurus-2.png);
        &.iddle{
          background-image: url(../assets/char/nunu-tidur-kurus-2.png);
        }
      }
      &.gemuk{
        background-image: url(../assets/char/nunu-gemuk-2.png);
        &.iddle{
          background-image: url(../assets/char/nunu-tidur-gemuk-2.png);
        }
      }
      &.lili{
        background-image: url(../assets/char/lili-normal-2.png);
        &.iddle{
          background-image: url(../assets/char/lili-tidur-normal-2.png);
        }
        &.kurus{
          background-image: url(../assets/char/lili-kurus-2.png);
          &.iddle{
            background-image: url(../assets/char/lili-tidur-kurus-2.png);
          }
        }
        &.gemuk{
          background-image: url(../assets/char/lili-gemuk-2.png);
          &.iddle{
            background-image: url(../assets/char/lili-tidur-gemuk-2.png);
          }
        }
      }
      .head{
        &.default1{
          background-image: url(../assets/acc/acc-winter-atas-2.png);
        }
        &.default2{
          background-image: url(../assets/acc/acc-summer-atas-2.png);
        }
        &.badut{
          background-image: url(../assets/acc/acc-badut-atas-2.png);
        }
        &.indo{
          background-image: url(../assets/acc/acc-indo-atas-2.png);
        }
        &.gym{
          background-image: url(../assets/acc/acc-gym-atas-2.png);
        }
        &.sekolah{
          background-image: url(../assets/acc/acc-sekolah-atas-2.png);
        }
        &.farmer{
          background-image: url(../assets/acc/acc-petani-atas-2.png);
        }
        &.gym2{
          background-image: url(../assets/acc/acc-gym2-atas-2.png);
        }
        &.lab{
          background-image: url(../assets/acc/acc-lab-atas-2.png);
        }
        &.bodykey{
          background-image: url(../assets/acc/acc-bk-atas-2.png);
        }
        &.indo2{
          background-image: url(../assets/acc/acc-indo2-2-atas.png);
        }
        &.paskib{
          background-image: url(../assets/acc/acc-paskib-2-atas.png);
        }
        &.hero{
          background-image: url(../assets/acc/acc-pahlawan-2-atas.png);
        }
        &.ai30{
          background-image: url(../assets/acc/acc-AI30-2-atas.png);
        }
        &.astro{
          background-image: url(../assets/acc/acc-astro-2.png);
        }
      }
      .face{
        &.default1{
          background-image: url(../assets/acc/acc-winter-tengah-2.png);
        }
        &.default2{
          background-image: url(../assets/acc/acc-summer-tengah-2.png);
        }
        &.badut{
          background-image: url(../assets/acc/acc-badut-tengah-2.png);
        }
        &.indo{
          background-image: url(../assets/acc/acc-indo-tengah-2.png);
        }
        &.gym{
          background-image: url(../assets/acc/acc-gym-tengah-2.png);
        }
        &.sekolah{
          background-image: url(../assets/acc/acc-sekolah-tengah-2.png);
        }
        &.farmer{
          background-image: url(../assets/acc/acc-petani-tengah-2.png);
        }
        &.bodykey{
          background-image: url(../assets/acc/acc-bk-tengah-2.png);
        }
        &.lab{
          background-image: url(../assets/acc/acc-lab-tengah-2.png);
        }
        &.gym2{
          background-image: url(../assets/acc/acc-gym2-tengah-2.png);
        }
        &.indo2{
          background-image: url(../assets/acc/acc-indo2-2-tengah.png);
        }
        &.paskib{
          background-image: url(../assets/acc/acc-paskib-2-tengah.png);
        }
        &.hero{
          background-image: url(../assets/acc/acc-pahlawan-2-tengah.png);
        }
        &.ai30{
          background-image: url(../assets/acc/acc-AI30-2-tengah.png);
        }
        &.astro{
          background-image: url(../assets/acc/acc-astro-2.png);
        }
      }
      .body{
        &.default1{
          background-image: url(../assets/acc/acc-winter-bawah-2.png);
        }
        &.default2{
          background-image: url(../assets/acc/acc-summer-bawah-2.png);
        }
        &.badut{
          background-image: url(../assets/acc/acc-badut-bawah-2.png);
        }
        &.indo{
          background-image: url(../assets/acc/acc-indo-bawah-2.png);
        }
        &.gym{
          background-image: url(../assets/acc/acc-gym-bawah-2.png);
        }
        &.sekolah{
          background-image: url(../assets/acc/acc-sekolah-bawah-2.png);
        }
        &.farmer{
          background-image: url(../assets/acc/acc-petani-bawah-2.png);
        }
        &.gym2{
          background-image: url(../assets/acc/acc-gym2-bawah-2.png);
        }
        &.lab{
          background-image: url(../assets/acc/acc-lab-bawah-2.png);
        }
        &.bodykey{
          background-image: url(../assets/acc/acc-bk-bawah-2.png);
        }
        &.indo2{
          background-image: url(../assets/acc/acc-indo2-2-bawah.png);
        }
        &.paskib{
          background-image: url(../assets/acc/acc-paskib-2-bawah.png);
        }
        &.hero{
          background-image: url(../assets/acc/acc-pahlawan-2-bawah.png);
        }
        &.ai30{
          background-image: url(../assets/acc/acc-AI30-2-bawah.png);
        }
        &.astro{
          background-image: url(../assets/acc/acc-astro-2.png);
        }
      }
      .finisher{
        background-image: url(../assets/acc/bendera-finisher2-2.png);
        &.bk3{
          background-image: url(../assets/acc/medali-finisher-2.png);
        }
      }
    }
  }
  &.charAn{
    .theChar{
      display: none;
      &.theChar2{
        display: block;
      }
    }
  }
}
.bg4 .charCnt .theChar{
  .finisherCnt{
    .finisher.bk3{
      background-image: url(../assets/acc/medali-finisher-astronot-1.png);
    }
  }
  &.theChar2{
    .finisher.bk3{
      background-image: url(../assets/acc/medali-finisher-astronot-2.png);
    }
  }
}


.calendarOverlay{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  z-index: 10;
  background-color: #000;
  opacity: .5;
}
.calendarCnt{
  position: fixed;
  left: 150px; right: 0; bottom: 0;
  z-index: 11;
  @media (max-width: 768px) {
    left: 0;
  }
}
.calendar{
  position: absolute;
  left: 0; right: 0; bottom: -96px;
  text-align: center;
  z-index: 11;
  color: #fff;
  background-color: #f76b21;
  border-radius: 15px 15px 0 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, .3);
  transition: all .3s ease;
  cursor: pointer;
  &:hover{
    background-color: #eb641c;
  }
  @media (min-width: 1300px) {
    right: auto; left: 50%;
    width: 1120px;
    margin-left: -560px;
  }
  &.open{
    bottom: 0;
  }
  &:before{
    content: "";
    background-color: #fff;
    width: 100px; height: 6px;
    border-radius: 50px;
    position: absolute;
    left: 50%; top: 10px;
    margin-left: -50px;
    opacity: .4;
  }
  h4{
    font-size: 20px;
    margin: 0;
    padding: 26px 0 20px;
    opacity: .9;
  }
  .calSc{
    overflow-x: auto;
  }
  .calCnt{
    display: flex;
    width: 1064px;
    padding: 0 8px 30px;
    margin: 0 auto;
    .calItem{
      width: 60px; height: 60px;
      border-radius: 50%;
      background-color: rgba(255, 255, 255, .2);
      margin: 0 8px;
      font-weight: bold;
      font-size: 26px;
      box-sizing: border-box;
      padding-top: 10px;
      transition: all .3s ease;
      position: relative;
      .calIcon{
        position: absolute;
        width: 20px; height: 20px;
        right: 0; top: 0;;
        background-position: center;
        background-size: cover;
      }
      &.passed{
        background-color: rgba(0, 0, 0, .08);
        color: rgba(0, 0, 0, .5);
        &.allCompleted{
          background-color: rgba(255, 255, 255, .2);
          color: #fff;
        }
        .calIcon{
          background-image: url(../assets/error.png);
        }
      }
      &.completed{
        &.passed{
          background-color: rgba(0, 0, 0, .08);
          color: rgba(0, 0, 0, .5);
        }
        .calIcon{
          background-image: url(../assets/checked-green.png);
        }
      }
      &.locked{
        background-color: rgba(0, 0, 0, .1);
        color: #000;
        color: rgba(0, 0, 0, .4) !important;
        color: transparent !important;
        // cursor: default !important;
        .calIcon{
          background-image: url(../assets/private.png);
          width: 30px; height: 30px;
          right: 15px; top: 13px;
          opacity: .5;
        }
      }
      &:hover{
        background-color: rgba(255, 255, 255, .3);
      }
      &.loading{
        // background-image: url(../assets/loading.svg);
        // background-position: center;
        // background-size: 36px auto;
        // background-repeat: no-repeat;
        // opacity: .8;
      }
      &.today{
        background-color: rgba(0, 0, 0, .1);
      }
      span{
        font-weight: normal;
        font-size: 11px;
        display: block;
        margin: 0 0 -4px;
      }
    }
  }
}
</style>
